module.exports = __webpack_public_path__ + "img/dzg_jp.4f224db4.png";